import React from 'react';

const CGV = () => {
  return (
    <div className="w-full min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto py-8 sm:py-12 px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-sm border border-gray-200 rounded-lg p-4 sm:p-6 lg:p-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6 sm:mb-8">
            Conditions Générales de Vente
          </h1>

          <div className="space-y-4 sm:space-y-6 text-gray-700 text-sm sm:text-base">
            
            {/* 1. Objet */}
            <section>
              <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">
                1. Objet
              </h2>
              <p>
                Les présentes Conditions Générales de Vente (CGV) définissent les droits et obligations 
                de l’association <strong>Crions D’Couleurs</strong> et des participants (ou de leurs représentants légaux) 
                dans le cadre de l’inscription à des séjours et colonies de vacances organisés par l’association.
              </p>
            </section>

            {/* 2. Champ d'application */}
            <section>
              <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">
                2. Champ d'application
              </h2>
              <p>
                Les présentes CGV s’appliquent à toutes les inscriptions effectuées via la plateforme en ligne 
                de Crions D’Couleurs. Toute inscription implique l’acceptation pleine et entière des présentes conditions.
              </p>
            </section>

            {/* 3. Inscription */}
            <section>
              <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">
                3. Inscription
              </h2>
              <p className="mb-3">
                L’inscription s’effectue exclusivement via la plateforme en ligne. 
                Pour être considérée comme valide, elle doit :
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Être complétée avec l’ensemble des informations demandées</li>
                <li>Être accompagnée des documents requis (fiche sanitaire, autorisations, etc.)</li>
                <li>Faire l’objet d’une validation par nos services</li>
                <li>Être confirmée par le paiement dans les délais impartis</li>
              </ul>
            </section>

            {/* 4. Tarifs et paiement */}
            <section>
              <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">
                4. Tarifs et paiement
              </h2>
              <p className="mb-3">
                Les tarifs sont indiqués en euros, toutes taxes comprises (TTC), et comprennent :
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>L’hébergement et la restauration</li>
                <li>Les activités prévues au programme</li>
                <li>L’encadrement par des animateurs qualifiés</li>
                <li>L’assurance responsabilité civile souscrite par l’association</li>
              </ul>


              <p className="mt-3">Le paiement peut être effectué selon les modalités suivantes :</p>
              <ul className="list-disc list-inside space-y-2 ml-4 mt-2">
                <li>Paiement en une fois au moment de l’inscription</li>
                <li>Paiement échelonné (sous réserve d’acceptation)</li>
                <li>Aides aux vacances (CAF, chèques vacances, comités d’entreprise, etc.)</li>
              </ul>
            </section>

            {/* 5. Annulation et remboursement */}
            <section>
              <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">
                5. Annulation et remboursement
              </h2>

              <div className="space-y-3">
                <div>
                  <h3 className="font-semibold text-gray-800 mb-2">5.1. Annulation par le participant</h3>
                  <p className="mb-2">En cas d’annulation par le client :</p>
                  <ul className="list-disc list-inside space-y-1 ml-4">
                    <li>Plus de 75 jours avant le départ : remboursement à 100 %.</li>
                    <li>Entre 75 et 30 jours avant le départ : remboursement à 40 %</li>
                    <li>Moins de 30 jours avant le départ : aucun remboursement</li>
                  </ul>
                  <p className="mt-2 text-sm">
                    Ces conditions ne s’appliquent pas en cas de force majeure ou de maladie justifiée par certificat médical.
                  </p>
                  <br></br>
                  <p className="mb-2">En cas de retour anticipé du participant à sa propre initiative ou celle de ses responsables légaux (hors force majeure), l'association étudiera la possibilité d'un éventuel remboursement au prorata des jours de présence. L'appréciation se fera en fonction de chaque dossier.</p>
                </div>

                <div>
                  <h3 className="font-semibold text-gray-800 mb-2">5.2. Annulation ou modification par l’association</h3>
                  <p>
                    L’association se réserve le droit d’annuler, de reporter ou de modifier un séjour 
                    en cas d’effectif insuffisant, de force majeure, de raisons de sécurité 
                    ou de toute circonstance indépendante de sa volonté.
                  </p>
                  <p className="mt-2">
                    En cas d’annulation du séjour par Crions D’Couleurs, les sommes versées seront
                    intégralement remboursées, sans qu’aucune autre indemnité ne puisse être réclamée.
                    En cas de retour anticipé de tout ou partie des participants pour cause de force majeure
                    (crise sanitaire, problème technique, etc.), le remboursement s’effectuera au prorata
                    des jours de présence.
                  </p>
                </div>
              </div>
            </section>

            {/* 6. Responsabilité */}
            <section>
              <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">6. Responsabilité</h2>
              <p className="mb-3">Crions D’Couleurs s’engage à :</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Assurer la sécurité et le bien-être des enfants pendant les séjours</li>
                <li>Respecter les normes d’encadrement et de sécurité réglementaires</li>
                <li>Disposer des assurances nécessaires</li>
              </ul>

              <p className="mt-3">La responsabilité de l’association ne saurait être engagée en cas de :</p>
              <ul className="list-disc list-inside space-y-2 ml-4 mt-2">
                <li>Force majeure (intempéries, crise sanitaire, etc.)</li>
                <li>Décision administrative ou événement imprévisible</li>
                
              </ul>
            </section>

            {/* 7. Règlement intérieur */}
            <section>
              <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">7. Règlement intérieur</h2>
              <p>
                Les participants doivent respecter le règlement intérieur et les consignes de vie collective. 
                En cas de manquement grave ou répété, et après information des parents, 
                l’enfant pourra être renvoyé du séjour. 
                Les frais de retour seront à la charge des responsables légaux, sans remboursement du séjour.
              </p>
            </section>

            {/* 8. Santé et assurance */}
            <section>
              <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">8. Santé et assurance</h2>
              <p>
                Les parents s’engagent à fournir des informations exactes et complètes sur la santé de leur enfant. 
                Toute omission ou fausse déclaration engage leur responsabilité. 
                L’association dispose d’une assurance responsabilité civile pour ses activités. 
                Les familles doivent s’assurer que leur enfant bénéficie d’une couverture individuelle accident 
                et d’une assurance responsabilité civile personnelle.
              </p>
            </section>

            

            {/* 9. Données personnelles */}
            <section>
              <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">9. Données personnelles</h2>
              <p>
                Les données personnelles collectées font l’objet d’un traitement conforme au RGPD. 
                Elles sont utilisées exclusivement pour la gestion des inscriptions et la sécurité des enfants. 
                Conformément à la réglementation, vous disposez d’un droit d’accès, de rectification et de suppression 
                en écrivant à <strong>cdccolonies@gmail.com</strong>. 
                Pour plus d’informations, consultez notre{' '}
                <a href="/politique-confidentialite" className="text-blue-600 hover:underline">
                  Politique de Confidentialité
                </a>.
              </p>
            </section>

            {/* 10. Réclamations */}
            <section>
              <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">10. Réclamations</h2>
              <p>
                Toute réclamation doit être adressée par écrit dans un délai de 30 jours suivant la fin du séjour :
              </p>
              <div className="mt-3 ml-4">
                <p><strong>Email :</strong> cdccolonies@gmail.com</p>
                <p><strong>Téléphone :</strong> 06.29.60.60.74</p>
              </div>
            </section>

            {/* 11. Médiation */}
            <section>
              <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">11. Médiation</h2>
              <p>
                Conformément à l’article L.612-1 du Code de la consommation, le participant peut recourir gratuitement 
                à un médiateur de la consommation en cas de litige non résolu à l’amiable. 
                À défaut, le litige sera soumis aux tribunaux compétents.
              </p>
            </section>

            {/* 12. Modification des CGV */}
            <section>
              <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">12. Modification des CGV</h2>
              <p>
                Crions D’Couleurs se réserve le droit de modifier les présentes CGV à tout moment. 
                Les CGV applicables sont celles en vigueur au moment de l’inscription.
              </p>
            </section>

            {/* 13. Contact */}
            <section>
              <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">13. Contact</h2>
              <div className="ml-4">
                <p><strong>Association Crions D'Couleurs</strong></p>
                <p><strong>Responsable :</strong> Dorian Ménager</p>
                <p><strong>Email :</strong> cdccolonies@gmail.com</p>
                <p><strong>Téléphone :</strong> 06.29.60.60.74</p>
              </div>
            </section>
          </div>

          <div className="mt-6 sm:mt-8 pt-4 sm:pt-6 border-t border-gray-200">
            <p className="text-xs sm:text-sm text-gray-500">
              Dernière mise à jour : 08/04/2026
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CGV;
